import * as AppConstants from './app.constants'

export const BASE_URL_LOCAL = `https://api.${AppConstants.DOMAIN}/`
export const BASE_URL_LOCAL_STORAGE = 'http://127.0.0.1:8000'

export const BASE_URL_REMOTE = `https://api.${AppConstants.DOMAIN}/`
export const BASE_URL_REMOTE_STORAGE = `https://api.${AppConstants.DOMAIN}`
